import { useFormik } from "formik"
import InputText from "global/InputText/InputText"
import Modal from "global/Modal/Modal"
import SimpleButton from "global/SimpleButton/SimpleButton"
import { nationalCodeValidation } from "global/Validation/Validation"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { getAPI } from "services/CRUDServices"
import {
  NationalCodeValidator,
  NationalIDValidator,
} from "tools/validations/ErrorHelper"

function NationlCodeValidation({ isOpen, setIsOpen }) {
  const { orderManagementData } = useSelector((state: any) => state.orderData)
  const [loading, setLoading] = useState(false)
  const { handleChange, handleSubmit, values, touched, errors, resetForm } =
    useFormik({
      validationSchema: nationalCodeValidation,
      initialValues: {
        nationalCode: "",
      },
      validate: (values) => {
        const errors = {} as any
        const [isValidNC, errNC] =
          values.nationalCode.length === 11
            ? NationalIDValidator(values.nationalCode)
            : NationalCodeValidator(values.nationalCode)
        if (!isValidNC) {
          errors.nationalCode = errNC
        }

        return errors
      },
      onSubmit: async (values) => {
        try {
          setLoading(true)
          await getAPI(
            `/customer-api/customer/shahkar/${orderManagementData.mobile}/${values.nationalCode}`
          )
          setIsOpen({ ...isOpen, verificationModal: true })
             setLoading(false)
        } catch {
          setLoading(false)
        }
      },
    })

  useEffect(() => {
    !isOpen && resetForm({})
  }, [isOpen])

  return (
    <Modal visible={isOpen} setVisible={setIsOpen} title='اعتبار سنجی'>
      <form onSubmit={handleSubmit}>
        <InputText
          label='کد ملی'
          name='nationalCode'
          handleChange={handleChange}
          values={values.nationalCode}
          important
          error={touched.nationalCode && errors.nationalCode}
        />

        <div className='btnForm'>
          <SimpleButton
            handelClick={() =>
              setIsOpen({ ...isOpen, nationalCodeValidation: false })
            }
            text='لغو'
            className='full-lightTomato-btn'
          />
          <SimpleButton
            type='submit'
            text={"اعتبار سنجی"}
            className='full-tomato-btn w-auto'
            loading={loading}
          />
        </div>
      </form>
    </Modal>
  )
}

export default NationlCodeValidation
